import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import {Trademark as TrademarkClient} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {onBeforeMount, ref} from "vue"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'trademark',
  props: {
    trademarkID: {
      default: null,
      required: true,
      type: String
    }
  },
  setup(__props) {

  const props = __props

  const error = ref<Error>(null)
  const trademarkClient = new TrademarkClient()
  const trademark = ref<Trademark>(null)

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      trademark.value = await trademarkClient.summary(props.trademarkID)
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, " Trademark ", -1)),
      (trademark.value)
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("th", null, " Name ", -1)),
                _createElementVNode("td", null, _toDisplayString(trademark.value.name), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("th", null, " Memorandum ", -1)),
                _createElementVNode("td", null, _toDisplayString(trademark.value.memorandum), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 1,
            error: error.value,
            "onUpdate:error": _cache[0] || (_cache[0] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})